// Single source of truth for which runner HTML serves each game dimension.
// TestPlay.jsx and GameCanvas.jsx MUST both use these so a new dimension can't be
// wired in one place and forgotten in the other (that bug shipped base games to the 2D runner).
const RUNNERS = {
  "3d": "/game-runner-3d.html",
  board: "/game-runner-board.html",
  party: "/game-runner-party.html",
  base: "/game-runner-base.html",
};

export function getRunnerSrc(dimension) {
  return RUNNERS[dimension] || "/game-runner.html";
}

export function getRunnerKey(dimension) {
  return dimension && RUNNERS[dimension] ? dimension : "2d";
}
